import "../../assets/css/educlip.scss";
import Header from "../../components/header";
import Footer from "../../components/footer";

import { useSearchParams } from "react-router-dom";
import { useDonationModal } from "../../hooks/use_donation_modal";
import DonationModalContainer from "../../components/modal/donate_modal_container";
import { useSubSalesValidation } from "../../hooks/use_sub_sales_validation";
import educlipMainKids from "../../assets/images/educlip/educlip_main_kids.png";
import educlipBanner from "../../assets/images/educlip/banner.png";
import yellowMonster from "../../assets/images/educlip/yellow_monster.png";
import { useEffect, useState } from "react";

function EduClipPage() {
  const [searchParams] = useSearchParams();
  const kdBusiness = searchParams.get("kd_business");
  const userRef = searchParams.get("usridx");

  const donationModal = useDonationModal();

  useSubSalesValidation(kdBusiness);

  const [openFaqIndex, setOpenFaqIndex] = useState(null);

  const courses = {
    grade3: [
      {
        category: "수학",
        title: "제50회 후기 전국 영어/수학 학력경시대회",
        description: "대회 기출문제 특강",
        subDescription: "이예하 선생님",
        detail: ["강의수: 15강", "수강기간: 15강"],
        price: "70,000원",
        tag: "VAT 포함",
        productSeq: "6",
      },
    ],
    grade4: [
      {
        category: "수학",
        title: "제50회 후기 전국 영어/수학 학력경시대회",
        description: "대비 기출문제 특강",
        subDescription: "김정은 선생님",
        detail: ["강의수: 15강", "수강기간: 34일"],
        price: "70,000원",
        tag: "VAT 포함",
        productSeq: "7",
      },
    ],
    grade5: [
      {
        category: "수학",
        title: "제50회 후기 전국 영어/수학 학력경시대회",
        description: "대비 기출문제 특강",
        subDescription: "김다은 선생님",
        detail: ["강의수: 15강", "수강기간: 34일"],
        price: "70,000원",
        tag: "VAT 포함",
        productSeq: "8",
      },
    ],
    grade6: [
      {
        category: "수학",
        title: "제50회 후기 전국 영어/수학 학력경시대회",
        description: "대비 기출문제 특강",
        subDescription: "정주창 선생님",
        detail: ["강의수: 15강", "수강기간: 34일"],
        price: "70,000원",
        tag: "VAT 포함",
        productSeq: "9",
      },
    ],
  };

  const features = [
    {
      title: "경시대회 대비 초등학생 3학년 ~ 6학년 학생들에게 도움 제공",
      description:
        "전문 강사진들이 국내 최고 수준급 수학경시대회를 준비하는 모든 학생들에게 도움 제공",
    },
    {
      title: "난이도별(상, 중, 하) 강의 구성을 통해 수준대별 학습",
      description:
        "기출문제 풀이를 통한 출제경향 및 문제유형 파악, 시험 철저대비",
    },
    {
      title: "커리큘럼",
      description: "총 15강으로 구성된 전문 강사를 통한 깊이있는 기출문제 특강",
    },
  ];

  const faqs = [
    {
      question: "환불은 가능한가요?",
      answer:
        "네, 에듀클립 환불 규정에 따라 진행됩니다.<br /><a href='https://kidsda.com/application/service#sec-12' target='_blank'>[환불정책 바로가기]</a> 자세한 환불정책을 확인하실 수 있습니다.",
    },
    {
      question: "어떻게 수강하나요?",
      answer:
        "구매하신 에듀클립 수강권을 '키즈다' 앱 내에 에듀클립 메뉴에서 쿠폰을 사용하여, 구매하신 특강을 수강하실 수 있습니다.",
    },
  ];

  // FAQ 토글 함수
  const toggleFaq = (index) => {
    setOpenFaqIndex(openFaqIndex === index ? null : index);
  };

  useEffect(() => {
    document.body.style.background = "white";
  }, []);

  return (
    <div className="educlip-container">
      <Header />

      <section className="hero-section">
        <div className="hero-inner">
          <div className="hero-content">
            <div className="hero-badge">에듀클립</div>
            <h1 className="hero-title">전국 영어 • 수학 학력경시대회 대비</h1>
            <p className="hero-description">
              기출문제풀이 특강
              <br />
              난이도별(상, 중, 하) 강의 구성을 통해 수준대별 학습
            </p>
          </div>
          <div className="hero-image">
            <img src={educlipMainKids} alt="학생 이미지" />
          </div>
        </div>
      </section>

      <section className="course-section">
        <h2 className="section-title">교육 플랫폼</h2>

        {Object.entries(courses).map(([grade, items], index) => (
          <div key={grade} className="grade-section">
            <h3 className="grade-title">{index + 3}학년</h3>
            <div className="course-grid">
              {items.map((course, idx) => (
                <div
                  key={idx}
                  className="course-card"
                  onClick={() => {
                    donationModal.startDonationProcess(course.productSeq);
                  }}
                >
                  <span className="course-category">
                    <span>✦ {course.category}</span>
                  </span>
                  <h4 className="course-title">{course.title}</h4>
                  <div className="course-description-box">
                    <p className="course-description">{course.description}</p>
                    <p className="course-subDescription">
                      {course.subDescription}
                    </p>
                    {course.detail && (
                      <p className="course-detail">
                        {Object.entries(course.detail).map(
                          ([key, value], index) => {
                            return <span key={key}>{value}</span>;
                          }
                        )}
                      </p>
                    )}
                  </div>
                  <div className="course-footer">
                    <span className="course-price">{course.price}</span>
                    <span className="course-tag">{course.tag}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </section>

      <section className="banner-section">
        <img src={educlipBanner} />
      </section>

      <section className="special-section">
        <div className="product-title">상품 안내</div>
        <div className="special-content">
          <div className="special-title-box">
            <div className="emoji-icon">
              <img src={yellowMonster} />
            </div>
            <div className="special-circle"></div>
            <h2 className="special-title">전국 영어・수학 학력경시대회</h2>
            <p className="special-description">
              수학경시대회 전문 강사를 통한 깊이있는 기출문제 특강,
              <br />
              문제 해결 접근법 향상
              <br />
              <br />- 기출문제 풀이를 통한 출제경향 및 문제유형 파악, 시험
              철저대비
              <br />- 난이도별(상, 중, 하) 강의 구성을 통해 수준대별 학습
              <br />- KMO, 성대경시대회, KMC 경시대회 전문 강사진
              <br />- 국내 최고 수준급 수학경시대회를 준비하는 모든 학생들에게
              도움 제공
            </p>
          </div>
          <div className="special-content-box">
            <ul className="special-list">
              {features.map((feature, idx) => (
                <li key={idx} className="special-item">
                  <div className="check-icon">✓</div>
                  <div className="special-item-content">
                    <h4>{feature.title}</h4>
                    <p>{feature.description}</p>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      <section className="faq-section">
        <h2 className="faq-title">자주 묻는 질문</h2>
        <div className="faq-list">
          {faqs.map((faq, idx) => (
            <div key={idx} className="faq-item">
              <div
                className="faq-question"
                onClick={() => toggleFaq(idx)}
                style={{ cursor: "pointer" }}
              >
                <span>{faq.question}</span>
                <span className="faq-icon">
                  {openFaqIndex === idx ? "−" : "+"}
                </span>
              </div>
              {openFaqIndex === idx && faq.answer && (
                <div
                  className="faq-answer"
                  dangerouslySetInnerHTML={{ __html: faq.answer }}
                ></div>
              )}
            </div>
          ))}
        </div>
      </section>

      <Footer />

      <DonationModalContainer
        {...donationModal}
        kdBusiness={kdBusiness}
        userRef={userRef}
        paymentType="card"
      />
    </div>
  );
}

export default EduClipPage;
